import { generatePath, Navigate, useParams } from 'react-router-dom'

import ProductsPage from 'features/product/pages/ProductsPage'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes'

export const AuthorizedProductsRoute = (): React.JSX.Element => {
  const ability = useAbility()
  const { workspaceId } = useParams<{ workspaceId: string }>()

  if (ability.can('access', 'ProductPage-list')) {
    return <ProductsPage />
  } else if (workspaceId && ability.can('access', 'FinancePage')) {
    return <Navigate to={generatePath(ROUTES.FINANCE, { workspaceId })} />
  } else {
    return <Navigate to={ROUTES.BASE.NOT_FOUND} />
  }
}
